import React from 'react'

import { AudioPlayer, AudioPlayerProps } from '@makyoapp/makyo-tw-ui'

export type CompAudioProps = AudioPlayerProps

/**
 * CompAudioCore
 */
export const CompAudioCore = React.memo(AudioPlayer)

CompAudioCore.displayName = 'CompAudioCore'
